import {useState} from 'react';

import {useSelector} from 'react-redux';

import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

import {useHasGlassesCare} from '../../../../hooks/useHasGlassesCare/useHasGlassesCare';
import {getIsOrderHasActiveSubscriptionCL} from '../../store/selectors/orderReviewItems/orderReviewItems';

/**
 * Manage Delivery form state
 */
export const useDeliveryFormState = () => {
    const {isOneStepAvailable} = useIsOneStepAvailable();
    const isCartHasActiveSubscriptionCL = useSelector(getIsOrderHasActiveSubscriptionCL);
    const isCartHasGlassesCare = useHasGlassesCare();
    const [isSubscriptionPopupEnabled, setSubscriptionPopupStatus] = useState(false);

    return {
        isCartHasActiveSubscriptionCL,
        isCartHasGlassesCare,
        isOneStepAvailable,
        isSubscriptionPopupEnabled,
        setSubscriptionPopupStatus,
    };
};
